import config from "../../../shared/config/config";
import axiosNoToken from "../../../shared/utils/axiosNoToken";
import axiosAdmin from "../../../shared/utils/axiosAdmin";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminLoginApi {
  adminSessionNew(): Promise<{ apiToken: string }>;
  adminSessionLogin(
    userId: string,
    password: string,
    otp: string
  ): Promise<any>;
  adminSendOTPEMail(userId: string): Promise<void>;
  adminOTPLogin(mailOTP: string): Promise<any>;
  adminUpdateNewPassword(
    userId: string,
    password: string,
    initOtp?: boolean
  ): Promise<void>;
  adminAskSupport(message: string): Promise<void>;
}

class AdminLoginServerApi implements AdminLoginApi {
  async adminSessionNew(): Promise<{ apiToken: string }> {
    const resp = await axiosNoToken.post<{ apiToken: string }>(
      `${GATEWAY_URL}/sessions/admins/new`
    );
    return resp.data;
  }
  async adminSessionLogin(
    userId: string,
    password: string,
    otp: string
  ): Promise<any> {
    const params = new URLSearchParams();
    params.append("userId", userId);
    params.append("password", password);
    params.append("otp", otp);
    const resp = await axiosNoToken.post<any>(
      `${GATEWAY_URL}/sessions/admins/login`,
      params
    );
    return Promise.resolve(resp.data);
  }
  async adminSendOTPEMail(userId: string): Promise<void> {
    let data = new FormData();
    data.append("userId", userId);

    const resp = await axiosNoToken.post<void>(
      `${GATEWAY_URL}/sessions/admins/otp/new`,
      data
    );

    return Promise.resolve(resp.data);
  }

  async adminOTPLogin(mailOTP: string): Promise<any> {
    let data = new FormData();
    data.append("mailOTP", mailOTP);

    const resp = await axiosNoToken.post<any>(
      `${GATEWAY_URL}/sessions/admins/otp/login`,
      data
    );

    return Promise.resolve(resp.data);
  }

  async adminUpdateNewPassword(
    userId: string,
    password: string,
    initOtp?: boolean
  ): Promise<void> {
    const data = new URLSearchParams();
    data.append("userId", userId);
    data.append("password", password);
    initOtp !== undefined && data.append("initOtp", initOtp.toString());

    const resp = await axiosAdmin.post<void>(
      `${GATEWAY_URL}/papi/passwd/admin/update`,
      data
    );

    return Promise.resolve(resp.data);
  }

  async adminAskSupport(message: string): Promise<void> {
    const resp = await axiosAdmin.post<void>(
      `${GATEWAY_URL}/wapi/admins/support`,
      { message: message }
    );

    return Promise.resolve(resp.data);
  }
}
const adminLoginApi: AdminLoginApi = new AdminLoginServerApi();
export default adminLoginApi;
